import { format, parseISO } from 'date-fns';
import copy from 'clipboard-copy';
import { toast } from 'react-toastify';
import { CouponScopeLabels } from '../../api/payments/coupons/domain/labels';

export function formatExpiresAt(expiresAt) {
  if (!expiresAt) return 'Sem data de expiração';
  return format(parseISO(expiresAt), 'dd/MM/yyyy');
}

export function formatDateTime(value) {
  return value ? format(parseISO(value), 'dd/MM/yyyy HH:mm') : '-';
}

export function formatAppliesTo(coupon) {
  const discounts = coupon?.discounts ?? [];
  if (!discounts.length) {
    return '-';
  }
  return discounts.reduce((acc, discount) => {
    const label = CouponScopeLabels[discount.scope];
    if (!label) return acc;
    return acc.length ? acc.concat(' - ', label) : acc.concat(label);
  }, '');
}

export function formatDiscount(coupon) {
  const value = coupon.discountValue ?? coupon.value;
  const valueType = coupon.discountValueType ?? coupon.valueType;
  if (value === undefined || value === null) return '-';
  return valueType === 'PERCENT' ? `${value}%` : `R$${value}`;
}

export function getInitialParams(searchBy) {
  const params = new URLSearchParams(searchBy);
  const page = Number(params.get('page')) || 1;
  const perPage = Number(params.get('perPage')) || 10;
  const search = params.get('search') || '';
  return { page, perPage, search: search };
}

export async function copyOfferLink(offer) {
  try {
    await copy(
      `${process.env.REACT_APP_JUSFY_URL}/payment-link/v2/${offer.codeHash}`,
    );
    toast.success('Link copiado!');
    return true;
  } catch (error) {
    console.error(error);
    toast.error('Não foi possível copiar o link');
    return false;
  }
}
